/** Contact: for a visitor who wants the product. Layout lives in `FormPage`. */
import { HUBSPOT } from "../demo";
import { FormPage } from "./FormPage";
import type { AsideItem } from "./FormPage";

const EXPECT: AsideItem[] = [
  {
    icon: "upload_file",
    text: "Send a few representative sheets - the messy ones are the useful ones.",
  },
  {
    icon: "tune",
    text: "We tune what gets extracted to your title blocks, tables and conventions.",
  },
  {
    icon: "integration_instructions",
    text: "Results come back as structured data - CSV today, your ERP or PLM next.",
  },
];

export function Contact() {
  return (
    <FormPage
      title="Contact us"
      caption="Tell us what you draw and what you need read off it. We will come back to you."
      formId={HUBSPOT.forms.contact}
      asideTitle="What to expect"
      aside={EXPECT}
    />
  );
}
